"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    ApiClient: Symbol("ApiClient"),
    IHttpClient: Symbol("IHttpClient"),
    IAbortSignal: Symbol("IAbortSignal")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ApiClient).to(_1.ApiClient);
});
exports.diModule = diModule;
